import React, { useState } from "react";

const SpecifIcation = ({ description }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      style={{
        background: "#eaeaea",
        border: "1px solid #ddd",
      }}
      className="specification-m001"
    >
      <div
        onClick={() => setOpen(!open)}
        style={{
          padding: "3px 10px",
          cursor: "pointer",
          fontSize: "16px",
          color: "#5f6367",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontWeight: "500",
          fontFamily:"Arial, Helvetica, sans-serif"
        }}
      >
        <span>SPECIFICATION</span>

        <i
          className={`bi ${
            open ? "bi-chevron-down" : "bi-chevron-right"
          }`}
        ></i>
      </div>

      {open && (
        <div
          style={{
            padding: "15px",
            background: "#f8f8f8",
            color: "#333",
            borderTop: "1px solid #ddd",
          }}
        >
          {description}
        </div>
      )}
    </div>
  );
};

export default SpecifIcation;